import { apiClient } from "../Pages/api/apiclient";

class UserService {

  static async login(email, password) {
    try {
      const response = await apiClient.post("/auth/login", {
        email,
        password,
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async register(userData) {
    try {
      const response = await apiClient.post("/auth/register/student", userData);
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  /**AUTHENTICATION CHECKER */
  static logout() {
    // Clear specific keys
    localStorage.removeItem("token");
    localStorage.removeItem("roleId");
    localStorage.removeItem("userName");
    localStorage.removeItem("email");
    localStorage.removeItem("id");
    localStorage.removeItem("ins"); // Added 'institute' key

    // OR clear everything from localStorage
    localStorage.clear();

    console.log("localStorage cleared:", localStorage);
  }

  static isAuthenticated() {
    if (typeof localStorage !== "undefined") {
      const token = localStorage.getItem("token");
      return !!token;
    } else {
      return false; // Handle the case when localStorage is not available
    }
  }
}

export default UserService;